import React from "react";

class Introduction extends React.Component {
  render() {
    return (
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <div className="section_title_container text-center">
                <div className="section_title">
                  <h1>ICITA Summer Symposium 2025</h1>
                </div>
              </div>
              <div className="intro_left_content text_left">
                <p align="left">
                  The 2025 Summer Symposium on Information Technology and
                  Applications will be held in Sydney, Australia, from 6 to 8
                  October 2025. This annual event brings together researchers,
                  educators, and industry professionals to share ideas, present
                  innovations, and discuss emerging developments in information
                  technology and its applications. This is the 1st edition of
                  ICITA symposium and it will continue a tradition of
                  high-quality academic exchange, offering an engaging and
                  collegial environment for collaboration. It provides a
                  valuable opportunity for participants to showcase their work,
                  build new connections, and strengthen cross-disciplinary and
                  international networks. Emphasizing both technical excellence
                  and practical relevance, the 2025 Summer Symposium encourages
                  dialogue that bridges research and application, and highlights
                  the growing impact of IT across diverse domains..{" "}
                </p>

                <p></p>
                <p align="left">
                  Since 2002 ICITA has maintained a high conference standard,
                  and several thousand academics and Information Technology
                  professionals have used it as a presenting, publishing and
                  networking medium for their research findings. We are
                  confident that more will be achieved during the next ten
                  years! The aim of International Conference on Information
                  Technology and Applications is to provide a platform for
                  academics and engineers in computer technology to meet,
                  exchange ideas, and establish professional networks. It is a
                  forum which will focus on specific disciplinary research as
                  well as on multi-disciplinary studies. The uniqueness of ICITA
                  is that it enables scientists in the world to communicate not
                  only about technical issues, but also any of the other areas
                  which use technology.
                </p>
                <p align="left">
                  Over the past many years, ICITA has been proudly sponsored by:
                  IEEE NSW Section, IEEE Computer Society, the University of
                  Technology Sydney, Australia; Charles Sturt University,
                  Australia; Heilongjiang University, China, Jiao-tong
                  University, China, University of Turin/Università degli Studi
                  di Torino, Italy, University Institute of Lisbon (ISCTE) -
                  Instituto Universitário de Lisboa, Portugal, and ACM SIG CHI
                  Singapore and Society of Industry Technology.
                </p>

                <br></br>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Introduction;
